import styles from '@/styles/Info.module.scss'
import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getPageTitle } from '@/utils/helpers'
import { useTranslation } from 'next-i18next'
import Raw from '@/components/common/Raw/Raw'
import classNames from 'classnames'

type Props = {}

const Terms = (props: Props) => {
  const { t } = useTranslation('terms')

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('title'))}</title>
      </Head>
      <main className={classNames(styles.info)}>
        <h1>{t('title')}</h1>

        <h3>{t('prices')}</h3>
        <p>
          {t('pricesText')}
        </p>

        <h3>{t('warranty')}</h3>
        <p>
          {t('warrantyText')}
        </p>

        <h3>{t('recommendation')}</h3>
        <p>
          {t('recommendationText')}
        </p>

        <h3>{t('buyInformation')}</h3>
        <p>
          <Raw content={t('buyInformationText')} />
        </p>

        <h3>{t('reget')}</h3>
        <p>
          <Raw content={t('regetText')} />
        </p>

        <h3>{t('refund')}</h3>
        <p>
          {t('refundText')}
        </p>

        <h3>{t('companyInvoice')}</h3>
        <br></br>
        <h5>{t('creditAssessmentHeading')}</h5>
        <p>
          {t('creditAssessment')}
        </p>
        <h5>{t('paymentTermsHeading')}</h5>
        <p>
          {t('paymentTerms')}
        </p>
        <h5>{t('invoiceTransferHeading')}</h5>
        <p>
          {t('invoiceTransfer')}
        </p>
        <h5>{t('GDPRHeading')}</h5>
        <p>
          {t('GDPR')}
        </p>
      </main>
    </BaseLayout>
  )
}

export default Terms

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'terms',
      'footer',
    ])),
  },
})